"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.function.name.js");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _fieldWrapper = _interopRequireDefault(require("../fieldWrapper"));

var _validations = require("../../validations");

var _validations2 = require("./validations");

var _Field = _interopRequireDefault(require("../../utils/Field"));

var _formElements = require("@evidation/form-elements");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useTranslated = require("../../hooks/useTranslated");

var _excluded = ["children", "input", "meta", "label", "placeholder", "disabled"];

var Spacer = _styledComponents["default"].div.withConfig({
  displayName: "emailConfirm__Spacer"
})(["display:block;height:10px;"]);

var Input = function Input(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? undefined : _ref$children,
      input = _ref.input,
      meta = _ref.meta,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? undefined : _ref$label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      disabled = _ref.disabled,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, null, label), /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _extends2["default"])({
    type: "email",
    placeholder: placeholder,
    disabled: disabled
  }, input)), meta.touched && meta.error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, meta.error), children && children);
};

Input.handlesErrorDisplay = true;

var EmailConfirm = function EmailConfirm(props) {
  var labelEnterEmail = (0, _useTranslated.useTranslated)('fields.emailConfirm.enterEmail');
  var labelReEnterEmail = (0, _useTranslated.useTranslated)('fields.emailConfirm.reEnterEmail');
  var validations = [_validations2.emailValidation];

  if (props.required) {
    validations = [_validations.required].concat((0, _toConsumableArray2["default"])(validations));
  }

  return /*#__PURE__*/_react["default"].createElement(_fieldWrapper["default"], props, /*#__PURE__*/_react["default"].createElement(_Field["default"], (0, _extends2["default"])({}, props, {
    placeholder: "email@email.com",
    label: labelEnterEmail,
    validate: (0, _toConsumableArray2["default"])(validations),
    name: "".concat(props.name, "_confirm"),
    component: Input
  }), /*#__PURE__*/_react["default"].createElement(Spacer, null)), /*#__PURE__*/_react["default"].createElement(_Field["default"], (0, _extends2["default"])({}, props, {
    placeholder: "email@email.com",
    label: labelReEnterEmail,
    validate: [].concat((0, _toConsumableArray2["default"])(validations), [_validations2.validateEquality]),
    name: props.name,
    component: Input
  })));
};

var _default = EmailConfirm;
exports["default"] = _default;